import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <header className="bg-blue-800 text-white py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-2">Terms & Conditions</h1>
          <p className="text-lg">Effective Date: [Insert Date]</p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-10 text-gray-700 leading-relaxed">
        <section className="mb-8">
          <p>
            By using <strong>Suitable Shelters</strong> at{" "}
            <a
              href="https://suitableshelters.com.ng"
              className="text-blue-600 underline"
            >
              https://suitableshelters.com.ng
            </a>, you agree to abide by the terms below. If you disagree, please do not use our website.
          </p>
        </section>

        <hr className="my-6 border-gray-300" />

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">1. Website Use</h2>
          <p>
            The website is intended for lawful activities related to viewing or inquiring about real estate listings in Nigeria.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">2. Property Listings</h2>
          <p>
            Listings are informational. We strive for accuracy but do not guarantee availability or property details.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">3. No User Accounts</h2>
          <p>
            Our platform does not require or support user accounts. Inquiries are made directly through our forms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">4. Intellectual Property</h2>
          <p>
            All content (text, images, branding) belongs to Suitable Shelters. Do not copy or use without written permission.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">5. Limitation of Liability</h2>
          <p>
            Suitable Shelters is not responsible for any decisions made based on site content or third-party property details.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">6. Changes to Terms</h2>
          <p>
            We may update these terms. Continued use of the website implies acceptance of any revised terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">7. Governing Law & Contact</h2>
          <p>
            These terms are governed by the laws of the Federal Republic of Nigeria. For inquiries, contact: <strong>{process.env.REACT_APP_CONTACT_US_EMAIL}</strong>
          </p>
        </section>
      </main>
    </div>
  );
};

export default TermsAndConditions;
